const config = {
  dynamicConfigBaseUrl: 'https://qa.new.northwesternmutual.com/assets/dynamic-config',
  basePath: 'https://qa.new.northwesternmutual.com',
  mediaBasePath: 'https://qa.media.northwesternmutual.com',
  adobeLaunchScript: '//assets.adobedtm.com/84f7e94eaa36/bb3bc880565f/launch-e98240bdad41-staging.min.js',
  services: {
    fieldApiBaseUrl: 'https://qa.new.northwesternmutual.com/nmx-api-proxy/nmx/ms-field',
    leadApiBaseUrl: 'https://qa.new.northwesternmutual.com/nmx-api-proxy/nmx/ms-form-proxy',
    preLeadApiBaseUrl: 'https://qa.new.northwesternmutual.com/nmx-api-proxy/nmx/ms-form-proxy',
    loginPageUrl: 'https://qa.login.northwesternmutual.com',
    searchApiBaseUrl: 'https://qa.new.northwesternmutual.com/nmx-api-proxy/nmx/ms-search',
    serviceRequestApiBaseUrl: 'https://qa.new.northwesternmutual.com/nmx-api-proxy/nmx/ms-form-proxy',
  },
};

module.exports = config;
